export const SVG_FINGERPRINT = 'febafb41c2fd60efa2bdaead993c7087';

// webchat spritesheet
export enum WebChatIcon {
  send = 'send-03',
  attachment = 'paperclip',
  attachment_audio = 'volume-min',
  attachment_document = 'file-06',
  attachment_image = 'image-01',
  attachment_location = 'marker-pin-01',
  attachment_video = 'video-recorder'
}
